/* unplugin-vue-components disabled */import script from "./VabMenuItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./VabMenuItem.vue?vue&type=script&lang=ts&setup=true"

import "./VabMenuItem.vue?vue&type=style&index=0&id=6ebb5e8d&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./VabMenuItem.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ebb5e8d"]])

export default __exports__